import * as z from 'zod'

function AvatarConCatch(puedeSerUrl: string): string | undefined {
  try {
    const parseo = z.url().safeParse(puedeSerUrl)
    if (!parseo.success)
      return undefined
    return parseo.data
  }
  catch (e) {
    console.error('Esto tenia que ser un url:', `"${puedeSerUrl}"`, e)
    return undefined
  }
}

export const AvatarOpcionalZod = z.preprocess(
  v => typeof v === 'string' ? AvatarConCatch(v.trim()) : undefined,
  z.url().optional()
)

export const IndexZod = z.preprocess(
  v => ((typeof v === 'string' && v !== 'null' && v !== 'undefined') ? v : undefined),
  z.string().min(1)
)

export const IDTextualZod = z.string()
export const IDTextualOpcionalZod = z.string().optional().catch(undefined)
export const IDNumericoOpcionalZod = z.number().optional().catch(undefined)

function preprocesadorNumero(v: unknown): number | undefined {
  if (typeof v === 'number' && !Number.isNaN(Number(v)))
    return v
  if (typeof v === 'string' && !Number.isNaN(Number(v)))
    Number(v)
  return undefined
}

export const IDNumericoZod = z.preprocess((v) => {
  const numeroOIndefinido = preprocesadorNumero(v)
  return (numeroOIndefinido && numeroOIndefinido !== 0) ? numeroOIndefinido : undefined
}, z.number())

export const NumeroZod = z.number()
export const NumeroOpcionalZod = z.number().optional().catch(undefined)
export const NumeroONullZod = z.number().nullable().default(null)
export const NumeroOCeroZod = z.number().default(0)

export const StringZod = z.string()
export const StringOpcionalZod = z.string().optional().catch(undefined)
export const StringONull = z.string().nullable().default(null)

export const URLZod = z.url()
export const URLOpcionalZod = z.url().optional().catch(undefined)

// export const BooleanZod = z.boolean()
export const BooleanZod = z.preprocess(v => {
  if (typeof v === 'boolean') return v
  if (v === 1) return true
  if (v === 0) return false
  return !!v
}, z.boolean())

export const BooleanOVerdaderoZod = z.boolean().default(true).catch(true)
export const BooleanOFalsoZod = z.boolean().default(false).catch(false)
export const BooleanOpcionalZod = z.boolean().optional().catch(undefined)

export const MontoZod = z.number().min(0).max(999999999)
export const MontoPositivoZod = z.number().min(1).max(999999999)

export const MonedasZod = z.enum(['CLP', 'USD', 'MXN', 'EUR', 'COP', 'CRC', 'PEN', 'BRL', 'BOB', 'HNL', 'ARS'])
export type Monedas = z.infer<typeof MonedasZod>

export const PrecioOpcionalZod = z.object({ monto: z.number(), moneda: z.preprocess(v => v === 'ARG' ? 'ARS' : v, MonedasZod) }).optional().catch(undefined)

export const ArrayCualquieraONada = z.preprocess(v => v ?? undefined, z.array(z.any()))

export function EsArray(puedeSer: unknown) {
  const revision = ArrayCualquieraONada.safeParse(puedeSer)
  return revision.success
}

export const EmailZod = z.string().check(z.trim(), z.email(), z.toLowerCase())
export const EmailOpcionalZod = EmailZod.optional().catch(undefined)

export const PassZod = z.string()
export const PassNuevoZod = z.string().min(6)
